import { render } from "./FinanceWarningBanner.vue?vue&type=template&id=faff0d90&lang=pug"
import script from "./FinanceWarningBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./FinanceWarningBanner.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__